module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-grid"
  }, [_c('div', {
    staticClass: "image-container",
    style: (_vm.styles)
  }, [_vm._l((_vm.images), function(image, index) {
    return (index < 4) ? _c('img', {
      key: image,
      ref: "images",
      refInFor: true,
      staticClass: "image",
      class: _vm.imageClass,
      attrs: {
        "src": image
      },
      on: {
        "click": function($event) {
          return _vm.imageSelected(index)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.remainingImages() > 0) ? _c('div', {
    class: ("excess-" + _vm.imageOrientation),
    on: {
      "click": function($event) {
        return _vm.showGallery(3)
      }
    }
  }, [_c('p', [_vm._v("+" + _vm._s(_vm.remainingImages()))])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c5250c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/ImageGrid.vue
// module id = 3269
// module chunks = 3